<template>
  <section class="app-main">
    <div class="contentplaceholder">
      <div class="container is-fluid app-content" id="contentholder">
       <levelbar></levelbar>
        <transition
          mode="out-in"
          enter-active-class="fadeIn"
          leave-active-class="fadeOut"
          appear>
          <!--<keep-alive>-->
            <router-view :key="$route.fullPath" class="animated"></router-view>
          <!--</keep-alive>-->
        </transition>
      </div>
    </div>
  </section>
</template>

<script>

  import Vue from 'vue'
  import Levelbar from './Levelbar'
  import {NotifierBus} from '../../store/eventbusses.js'
  import Notification from './Notification'

  const NotificationComponent = Vue.extend(Notification)

  const openNotification = (propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  }) => {
    return new NotificationComponent({
      el: document.createElement('div'),
      propsData
    })
  }

  export default {
    components: {
      Levelbar
    },
    data () {
      return {
        loaded: false
      }
    },
    created: function () {
      if (NotifierBus.HasSubscribers) {
        return
      }
      NotifierBus.HasSubscribers = true
      NotifierBus.$on('Notify', notification => {
        openNotification({
          title: notification.title,
          message: typeof notification.message === 'undefined' || notification.message === '' ? 'Unkown Error' : notification.message,
          type: notification.type,
          duration: typeof notification.duration === 'undefined' ? 4500 : notification.duration
        })
      })
    }
  }
</script>

<style type="css">
  @media screen and (min-width: 800px) {
    .contentplaceholder {
      margin-left: 0.6rem;
      margin-right: 0.6rem;
    }
  }

  #contentholder {
    margin-left:0px
  }

</style>



// WEBPACK FOOTER //
// AppMain.vue?9aaf88e8